<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-team-list [listType]="DtgListType.list"></dtg-manage-team-list>
    </div>
</div>